import { render } from "./GamePG.vue?vue&type=template&id=17dbd51c"
import script from "./GamePG.vue?vue&type=script&lang=js"
export * from "./GamePG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__